import React from 'react';
import { useTranslation } from 'react-i18next';
import AccessGroupList from 'components/administration/staff/AccessGroupList';
import PropTypes from 'prop-types';
import AccesList from 'components/administration/staff/AccessList';
import axios from 'axios';
import { authHeaders } from 'actions';
import Routes from 'utils/routes.js.erb';
import { useQuery } from '@tanstack/react-query';

const OrganizationAccess = ({
  groups,
  subgroups,
  cohorts,
  delGroup,
  delSubgroup,
  delCohort,
  addGroup,
  addSubgroup,
  addCohort,
}) => {
  const { t } = useTranslation();
  const accesses = useQuery({
    queryKey: ['administration', 'organization', 'my-accesses'],
    queryFn: ({ signal }) => axios.get(
      Routes.api_dashboard_administration_organizations_my_accesses_path(),
      { headers: authHeaders(), signal }
    ).then(response => response.data),
  })

  const allGroups = (accesses.data?.groups ?? [])
  const allSubgroups = (accesses.data?.subgroups ?? [])
  const allCohorts = (accesses.data?.cohorts ?? [])

  return (
    <div className='o-card__wrap'>
      <section className='column o-card cs-bg--light'>
        <h4>
          <b>{t('administration.staff.organizationAccessTitle')}</b>
        </h4>
        <AccesList title={t('administration.staff.groups.title')} items={groups} />
        <AccesList title={t('administration.staff.subgroups.title')} items={subgroups} />
        <AccesList title={t('administration.staff.cohorts.title')} items={cohorts} />
        <br />
        <br />
        <br />
        {allGroups.filter(i => !i.disabled).length > 0 && (
          <AccessGroupList title={t('administration.staff.groups.title')} items={groups} allItems={allGroups} deleteFunction={delGroup} addFunction={addGroup}
            subTitle={(<p className='u-txt--label'>{t('administration.staff.groups.info')}</p>)}
          />
        )}
        <br />
        {allSubgroups.filter(i => !i.disabled).length > 0 && (
          <AccessGroupList title={t('administration.staff.subgroups.title')} items={subgroups} allItems={allSubgroups} deleteFunction={delSubgroup} addFunction={addSubgroup}
            subTitle={(<p className='u-txt--label'>{t('administration.staff.subgroups.info')}</p>)}
          />
        )}
        <br />
        {allCohorts.filter(i => !i.disabled).length > 0 && <AccessGroupList title={t('administration.staff.cohorts.title')} items={cohorts} allItems={allCohorts} deleteFunction={delCohort} addFunction={addCohort} /> }
      </section>
    </div>
  )
};

OrganizationAccess.propTypes = {
  auth: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  subgroups: PropTypes.array.isRequired,
  cohorts: PropTypes.array.isRequired,
  delGroup: PropTypes.func.isRequired,
  delSubgroup: PropTypes.func.isRequired,
  delCohort: PropTypes.func.isRequired,
  addGroup: PropTypes.func.isRequired,
  addSubgroup: PropTypes.func.isRequired,
  addCohort: PropTypes.func.isRequired,
}

export default OrganizationAccess;
